export default __webpack_public_path__ + "static/media/question.593b268e.svg";